import LoadingFullPageModal from "../../components/loadingFullPageModal/loadingFullPageModal";

export default function GoogleRedirectPage() {
    return (
        <div>
            <LoadingFullPageModal guestMode={true} reverse={false} />
        </div>
    );
}
